import React from 'react';

export default function ReceiptDetails() {
  return <div>ReceiptDetails</div>;
}
